export default __webpack_public_path__ + "static/media/brain.c68ff421.png";